import {
  Body,
  Button,
  Drawer,
  Select,
  TextArea,
} from "@songtradr-one/components-frontend";
import { Flex } from "@songtradr-one/shared-frontend";
import {
  ButtonContainer,
  INQUIRY_OPTIONS,
  Props,
  StudioSupportLogo,
  text,
  useCustomerSupport,
} from "./CustomerSupport.Parts";

export const CustomerSupport = ({ onOpenChange }: Props) => {
  const {
    isOpen,
    inquiry,
    setInquiry,
    category,
    setCategory,
    loading,
    handleOpenChange,
    handleSubmit,
  } = useCustomerSupport({ onOpenChange });

  return (
    <Drawer
      open={isOpen}
      onOpenChange={handleOpenChange}
      title={text.title}
      origin="right"
    >
      <Flex $direction="column" $gap="1.5rem">
        <Flex $align="center" $wrap="nowrap">
          <StudioSupportLogo src="https://assets.studio.massivemusic.com/statics/studio-support-header-logo" />
          <Flex $direction="column" $gap="0rem">
            <Body variant="normal-strong">{text.descriptionOne}</Body>
            <Body>{text.descriptionTwo}</Body>
          </Flex>
        </Flex>
        <Select
          placeholder={text.selectPlaceholder}
          width="100%"
          floating={false}
          options={INQUIRY_OPTIONS}
          selection={category ? [category] : []}
          onChange={(selection: (string | number)[]) =>
            setCategory(selection[0]?.toString() || "")
          }
          name={text.selectLabel}
          label={text.selectLabel}
        />
        <TextArea
          ref={(el) => {
            if (el && isOpen) setTimeout(() => el.focus(), 0);
          }}
          width="100%"
          label={text.textAreaLabel}
          value={inquiry}
          onChange={(e) => setInquiry(e.target.value)}
        />
        <ButtonContainer>
          <Button
            $variant="primary"
            disabled={!inquiry.length || !category}
            onClick={handleSubmit}
            loading={loading}
          >
            {text.submitButton}
          </Button>
        </ButtonContainer>
      </Flex>
    </Drawer>
  );
};
